module.exports = __webpack_public_path__ + "img/undo-white.f3fb7cfa.svg";